export default __webpack_public_path__ + "static/media/discord_logo.ebd4729e.svg";